import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import UndoableItem from "./UndoableItem.jsx";
import getCategoryById from "../../../utilities/getCategoryById.js";
import { submitBudgetUpdate } from "../../../redux/actions/dashboard.js";


export default function BudgetSubmitUndo() {
	const dispatch = useDispatch();
	const lastChangedBudget = useSelector((state) => state.dashboard.lastChangedBudget);

	function getItemId(budget) {
		if(!budget.category_id) {
			throw new Error('budget does not have a category id!');
		}
		return `${budget.category_id}-${budget.month}-${budget.year}`;
	}

	function undoButtonClicked(budget) {
		console.log('find update budget function');
		budget.revert();
		dispatch(submitBudgetUpdate(budget.category, budget));
	}

	function getName(budget) {
		const category = budget.category;
		return category.name;
	}

	function itemHasChangeThatCanBeUndone(item) {
		return true;
	}

	return (
		<UndoableItem
			item={lastChangedBudget}
			getItemId={getItemId}
			itemHasChangeThatCanBeUndone={itemHasChangeThatCanBeUndone}
			undoButtonClicked={undoButtonClicked}
			afterClickedUndoContent={(budget) => {
				return `Restored ${getName(budget)}`;
			}}
			canUndoContent={(budget) => {
				return (
					<span>Updated Budget for <span className='institution_name'>{getName(budget)}</span></span>
				);
			}}
		/>
	);
}